const SET_SECTION_POSITION = 'total-word/SET_SECTION_POSITION';

const SET_CHART_POSITION = 'total-word/SET_CHART_POSITION';
const SET_CHART_STICKED = 'total-word/SET_CHART_STICKED';
const SET_CHART_UNSTICKED = 'total-word/SET_CHART_UNSTICKED';

const SET_CHART_STICKED_TOP = 'total-word/SET_CHART_STICKED_TOP';
const SET_CHART_STICKED_BOTTOM = 'total-word/SET_CHART_STICKED_BOTTOM';

const SET_LOWEST_NOTE_POSITION = 'total-word/SET_LOWEST_NOTE_POSITION';
const SHOW_LOWEST_NOTE = 'total-word/SHOW_LOWEST_NOTE';
const HIDE_LOWEST_NOTE = 'total-word/HIDE_LOWEST_NOTE';

const SET_HIGHEST_NOTE_POSITION = 'total-word/SET_HIGHEST_NOTE_POSITION';
const SHOW_HIGHEST_NOTE = 'total-word/SHOW_HIGHEST_NOTE';
const HIDE_HIGHEST_NOTE = 'total-word/HIDE_HIGHEST_NOTE';

const SET_SUMMARY_NOTE_POSITION = 'total-word/SET_SUMMARY_NOTE_POSITION';
const SHOW_SUMMARY_NOTE = 'total-word/SHOW_SUMMARY_NOTE';
const HIDE_SUMMARY_NOTE = 'total-word/HIDE_SUMMARY_NOTE';

export default {
  SET_SECTION_POSITION,
  SET_CHART_POSITION,
  SET_CHART_STICKED,
  SET_CHART_UNSTICKED,
  SET_CHART_STICKED_TOP,
  SET_CHART_STICKED_BOTTOM,
  SHOW_LOWEST_NOTE,
  HIDE_LOWEST_NOTE,
  SET_LOWEST_NOTE_POSITION,
  SHOW_HIGHEST_NOTE,
  HIDE_HIGHEST_NOTE,
  SET_HIGHEST_NOTE_POSITION,
  SET_SUMMARY_NOTE_POSITION,
  SHOW_SUMMARY_NOTE,
  HIDE_SUMMARY_NOTE
};



// WEBPACK FOOTER //
// ./src/state/totalWord/types.js